export type SiteSearchGroup = 'หน้า' | 'หน่วยงาน' | 'แบบฟอร์ม';

export type SiteSearchHit = {
  id: string;
  label: string;
  hint: string;
  href: string;
  group: SiteSearchGroup;
  departmentId?: string;
};

/**
 * Trim, collapse whitespace, NFC, then lower case.
 * JavaScript NFC does not compose nikahit + sara aa into Sara Am, so fold that pair ourselves.
 * Thai letters have no case. Thai digits stay Thai digits.
 */
export function normalizeSearchText(value: string): string {
  return value
    .normalize('NFC')
    .replace(/\u0E4D\u0E32/g, '\u0E33')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();
}

export function matchesSearchQuery(query: string, label: string): boolean {
  const normalizedQuery = normalizeSearchText(query);
  if (normalizedQuery.length < 2) return false;
  const normalizedLabel = normalizeSearchText(label);
  if (normalizedLabel.includes(normalizedQuery)) return true;
  const compactQuery = normalizedQuery.replace(/ /g, '');
  if (compactQuery.length < 2) return false;
  return normalizedLabel.replace(/ /g, '').includes(compactQuery);
}

export function isInAppSearchHref(href: string): boolean {
  const trimmed = href.trim();
  return trimmed.startsWith('/') && !trimmed.startsWith('//');
}

/** App path with one leading slash, or an http(s) URL. Drops javascript, data, and protocol-relative links. */
export function isAllowedSearchHref(href: string): boolean {
  const trimmed = href.trim();
  if (!trimmed) return false;
  if (isInAppSearchHref(trimmed)) return true;
  try {
    const url = new URL(trimmed);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}

export function hitMatchesQuery(hit: Pick<SiteSearchHit, 'label' | 'hint'>, query: string): boolean {
  if (matchesSearchQuery(query, hit.label)) return true;
  if (hit.hint && matchesSearchQuery(query, hit.hint)) return true;
  return false;
}
